// Typelizer digest 4adb6618ac007fa667c611493a222693
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** GET / */
  root: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/', {}, options),
    method: 'get',
  }),

  /** GET / */
  home: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/', {}, options),
    method: 'get',
  }),
}
